/* unplugin-vue-components disabled */import { render } from "./CategorySwiper.vue?vue&type=template&id=691d61e2&scoped=true"
import script from "./CategorySwiper.vue?vue&type=script&lang=js"
export * from "./CategorySwiper.vue?vue&type=script&lang=js"

import "./CategorySwiper.vue?vue&type=style&index=0&id=691d61e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-691d61e2"]])

export default __exports__